import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { t } from '../../../utils/textUtils';
import ProjectCard from './ProjectCard';

const CurrentProject = ({ 
  dashboardOverviewData, 
  activeProjects, 
  displayName,
  statusColors,
  getProgressColor
}) => {
  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{ 
          p: { xs: 2, sm: 3 }, 
          borderRadius: 2, 
          borderColor: 'divider',
          bgcolor: '#ffffff',
          minHeight: '450px'
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 1
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a' }}>
            {t('PROYEK BERJALAN')}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {displayName}
          </Typography>
        </Box>
        {(dashboardOverviewData.runningProjects || activeProjects).length > 0 ? (
          (dashboardOverviewData.runningProjects || activeProjects).slice(0, 1).map((project, index) => (
            <ProjectCard 
              key={project.id || `project-${index}`}
              project={project}
              statusColors={statusColors}
              getProgressColor={getProgressColor}
            />
          ))
        ) : (
          <Box sx={{ py: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {t('TIDAK ADA PROYEK AKTIF DITEMUKAN')}
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default CurrentProject;
